function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createUseStyles } from 'react-jss';
var DEFAULT_HEIGHT = 80;
var useStyles = createUseStyles(function (_ref) {
  var spacing = _ref.spacing,
    shadow = _ref.shadow,
    palette = _ref.palette,
    type = _ref.type;
  return {
    accountCard: {
      fontFamily: type.fontFamily.base,
      fontSize: type.fontSize.body,
      '-webkit-font-smoothing': 'antialiased',
      backgroundColor: palette.background.light,
      border: "2px solid ".concat(palette.border.muted),
      borderRadius: '4px',
      boxShadow: shadow.none,
      position: 'relative',
      // hover styles for interactive card
      '&:hover, &:focus': {
        borderColor: palette.border.hover,
        cursor: 'pointer'
      }
    },
    // These styles get added conditionally based on component props
    accountCardDynamic: function accountCardDynamic(_ref2) {
      var selected = _ref2.selected;
      return _objectSpread({}, selected && {
        borderColor: palette.border.active,
        '&:hover, &focus': {
          borderColor: palette.border.active
        }
      });
    },
    accountCardBody: function accountCardBody(_ref3) {
      var loading = _ref3.loading,
        _ref3$height = _ref3.height,
        height = _ref3$height === void 0 ? DEFAULT_HEIGHT : _ref3$height;
      return _objectSpread({
        padding: "0 ".concat(spacing[4], "px"),
        minHeight: "".concat(height, "px"),
        display: 'flex',
        alignItems: 'center'
      }, loading ? {
        justifyContent: 'center'
      } : {});
    },
    accountType: {
      position: 'absolute',
      top: 0
    },
    spinner: {
      minHeight: '100%'
    }
  };
});
export default useStyles;
//# sourceMappingURL=useStyles.js.map